module.exports = __webpack_public_path__ + "static/media/l-md17.16147aa0.png";